import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { UserRegistrationModel } from "../models/userRegistration/userRegistration";
let UserRegistrationModule = /** @class */ (() => {
    var _a, _b, _c;
    let UserRegistrationModule = class UserRegistrationModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.Timezones = [];
        }
        async GetTimezoneForUserRegistration() {
            let { data } = await service.get("UserRegistration");
            if (data) {
                this.SetTimeZone(data.timezones);
                return data;
            }
        }
        SetTimeZone(Timezones) {
            this.Timezones = Timezones;
        }
        async SaveUserRegistration(userRegistration) {
            let { data } = await service.post("UserRegistration", userRegistration);
            return data;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], UserRegistrationModule.prototype, "GetTimezoneForUserRegistration", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], UserRegistrationModule.prototype, "SetTimeZone", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof UserRegistrationModel !== "undefined" && UserRegistrationModel) === "function" ? _b : Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], UserRegistrationModule.prototype, "SaveUserRegistration", null);
    UserRegistrationModule = __decorate([
        Module({ dynamic: true, store: store, name: "userRegistration", namespaced: true })
    ], UserRegistrationModule);
    return UserRegistrationModule;
})();
export default getModule(UserRegistrationModule);
